import React from 'react';

import mainPageConfig from '../config/mainPageConfig';
import { usePageStore } from '../store/pageStore/context/pageContext';

const usePageConfig = (pageName: string): void => {
    const pageConfig = mainPageConfig[pageName];
    const { pageActions } = usePageStore();

    React.useEffect(() => {
        if (pageConfig) {
            pageActions.pageConfig.setPageConfig({ pageName, pageConfig });
        }
    }, []);
};

export default usePageConfig;
